import {
	getPhysicalSensorsCountResolved,
	getPhysicalSensorsCountRejected,
	getPhysicalSensorsCount,
} from '@Actions/sensors';
import { AnyAction, createReducer } from '@reduxjs/toolkit';
import { PhysicalSensorCountStore } from '@Types/sensor.types';

export const initialState: PhysicalSensorCountStore = {
	initialized: false,
	isError: false,
};

export interface PhysicalSensorCount {
	[x: string]: (
		state: PhysicalSensorCountStore,
		action: AnyAction,
	) => PhysicalSensorCountStore | undefined;
}

const reducer: PhysicalSensorCount = {
	[getPhysicalSensorsCount.toString()]: state => ({
		...state,
		initialized: false,
		isError: false,
		physicalCount: undefined,
	}),
	[getPhysicalSensorsCountResolved.toString()]: (state, action) => ({
		...state,
		initialized: true,
		isError: false,
		physicalCount: action.payload,
	}),
	[getPhysicalSensorsCountRejected.toString()]: state => ({
		...state,
		initialized: true,
		isError: true,
		physicalCount: 0,
	}),
};

export default createReducer(initialState, reducer);
